import { Component, Input, OnChanges, OnInit, ViewChild } from "@angular/core";
import {
  ControlContainer,
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  FormGroupDirective,
} from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { MatMenuTrigger } from "@angular/material/menu";
import { ConfigureFilterComponent } from "@dialogs/configure-filter/configure-filter.component";
import { ConfirmationDialogComponent } from "@dialogs/confirmation/confirmation.component";
import { FilterLogicComponent } from "@dialogs/filter-logic/filter-logic.component";
import {
  faSearch,
  faExclamationTriangle,
} from "@fortawesome/pro-light-svg-icons";
import { faPlus } from "@fortawesome/pro-regular-svg-icons";
import { faTrash, faEdit } from "@fortawesome/pro-solid-svg-icons";
import { CommonService } from "@services/common.service";
import { DatapointService } from "@services/datapoint.service";
import { CanvasService } from "@services/canvas.service";
import { environment } from "@environments/environment";

@Component({
    selector: "app-filters",
    templateUrl: "./filters.component.html",
    styleUrls: ["./filters.component.scss"],
    viewProviders: [
        { provide: ControlContainer, useExisting: FormGroupDirective },
    ],
    standalone: false
})
export class FiltersComponent implements OnInit, OnChanges {
  @ViewChild("fieldMenuTrigger") fieldMenuTrigger!: MatMenuTrigger;

  @Input() currentFilterFields!: any;
  @Input() currentDataFields!: any;
  @Input() departmentScope!: any;
  @Input() employeeScope!: any;
  constructor(
    private fb: UntypedFormBuilder,
    public parentF: FormGroupDirective,
    public commonService: CommonService,
    private canvasService: CanvasService,
    public datapointService: DatapointService,
    public dialog: MatDialog
  ) {}

  public dataFields: any[] = [];
  public filterFields: any[] = [];
  public canvasFields: any[] = [];

  public categories: any = [];
  public fieldForm!: UntypedFormGroup;
  public error: string = "";
  public page: number = 1;
  public count: number = 200;
  public moreFilters: boolean = true;
  public loading!: boolean;
  faPlus = faPlus;
  faSearch = faSearch;
  faEdit = faEdit;
  faTrash = faTrash;
  faExclamationTriangle = faExclamationTriangle;

  childForm: any;
  selectedIndex = -1;
  public aggregateData: any = [];
  public filterLogicMapping: any;

  public chartID: number = 0;
  public enableBooleanLogic = environment.disableUI.enableBooleanLogic || false;

  openmappingList(event: any) {
    if (event) event.stopPropagation();
    let filterLogicMapping;

    if (this.childForm.get("filterLogicMapping").value)
      filterLogicMapping =
        this.childForm.get("filterLogicMapping")!.value.mappingList;
    const dialogRef = this.dialog.open(FilterLogicComponent, {
      width: "1100px",
      height: "80vh",
      disableClose: true,
      data: {
        filterFields: this.filterFields,
        filterLogicMapping: filterLogicMapping,
      },
      panelClass: "canvas-dialog",
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.childForm.get("filterLogicMapping")!.setValue(result);
        this.filterLogicMapping = result;
        this.buildAggregateData();
      }
    });
  }

  createItem(conditionVal?: string): UntypedFormGroup {
    if (conditionVal) {
      return this.fb.group({
        condition: [conditionVal],
      });
    } else {
      return this.fb.group({
        condition: ["and"],
      });
    }
  }

  addItem(conditionVal?: string): void {
    if (this.fieldForm) {
      let condition = this.fieldForm.get("conditions") as UntypedFormArray;
      if (conditionVal) {
        condition.push(this.createItem(conditionVal));
      } else {
        condition.push(this.createItem());
      }
    }
  }
  deleteItem(idx: number) {
    let condition = this.fieldForm.get("conditions") as UntypedFormArray;
    condition.removeAt(idx);
  }

  addFilter() {
    let selected = this.fieldForm.get("selectItem")!.value;
    const itemtoMove = this.currentDataFields.filter((item: any) => {
      return item.id == selected;
    });
    if (itemtoMove[0]) {
      this.filterFields.push(itemtoMove[0]);
      this.addItem();
      setTimeout(() => {
        this.configureFilter(
          null,
          this.filterFields.length - 1,
          this.filterFields[this.filterFields.length - 1].id,
          this.filterFields[this.filterFields.length - 1],
          true,
          true
        );
      }, 100);
      this.buildAggregateData();
    }
  }

  addDynamic() {
    this.departmentScope = true;
    this.childForm.get("departmentScope")!.setValue(true);
    this.fieldForm.get("selectItem")!.setValue("");
    this.buildAggregateData();
  }
  removeDynamic(event: any, index: number) {
    this.selectFilter(true, index);
    const elem = "filterRight-" + index;
    const element = document.getElementById(elem);
    const rect = element
      ? element.getBoundingClientRect()
      : { top: 0, left: 0 };

    if (event) {
      event.stopPropagation();
      const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
        disableClose: true,
        data: {
          message: "Remove this filter?",
          actionButton: "remove",
        },
        panelClass: ["canvas-dialog", "dialog-right"],
        position: { top: rect.top - 50 + "px", left: rect.left - 380 + "px" },
      });

      dialogRef.afterClosed().subscribe((result) => {
        this.selectFilter(false, index);
        if (result) {
          this.departmentScope = false;
          this.childForm.get("departmentScope")!.setValue(false);
          this.buildAggregateData();
        }
      });
    }
  }

  addDynamicUser() {
    this.employeeScope = true;
    this.childForm.get("employeeScope")!.setValue(true);
    this.fieldForm.get("selectItem")!.setValue("");
    this.buildAggregateData();
  }
  removeDynamicUser(event: any, index: number) {
    this.selectFilter(true, index);
    const elem = "filterRight-" + index;
    const element = document.getElementById(elem);
    const rect = element
      ? element.getBoundingClientRect()
      : { top: 0, left: 0 };

    if (event) {
      event.stopPropagation();
      const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
        disableClose: true,
        data: {
          message: "Remove this filter?",
          actionButton: "remove",
        },
        panelClass: ["canvas-dialog", "dialog-right"],
        position: { top: rect.top - 50 + "px", left: rect.left - 380 + "px" },
      });

      dialogRef.afterClosed().subscribe((result) => {
        this.selectFilter(false, index);
        if (result) {
          this.employeeScope = false;
          this.childForm.get("employeeScope")!.setValue(false);
          this.buildAggregateData();
        }
      });
    }
  }

  moveItemtoList(id: number) {
    this.error = "";
    const itemtoMove = this.dataFields.filter((item: any) => {
      return item.id == id;
    });
    this.filterFields.push(itemtoMove[0]);
    this.addItem();

    setTimeout(
      () =>
        this.configureFilter(
          null,
          this.filterFields.length - 1,
          this.filterFields[this.filterFields.length - 1].id,
          this.filterFields[this.filterFields.length - 1],
          true
        ),
      100
    );

    this.buildAggregateData();
  }
  setConfigValue(field: any) {
    let returnVal = "Configure Filter";

    if (field.fields && field.fields.data.length > 0) {
      returnVal = "Filter Configured";
    }
    if (field.filters && field.filters.data.length > 0) {
      returnVal = "Filter Configured";
    }
    return returnVal;
  }

  configureFilter(
    event: any,
    index: number,
    id: number,
    field: any,
    auto: boolean,
    logic?: boolean
  ) {
    if (event) event.stopPropagation();

    this.selectFilter(true, index);
    const elem = "filterRight-" + index;
    const element = document.getElementById(elem);
    const rect = element
      ? element.getBoundingClientRect()
      : { top: 0, left: 0 };

    let dialogRef: any = this.dialog;

    if (rect.top == 0) {
      dialogRef = this.dialog.open(ConfigureFilterComponent, {
        width: "500px",
        disableClose: true,
        data: {
          message: "Configure this filter",
          id: id,
          field: field,
          auto: auto,
        },
        panelClass: "canvas-dialog",
      });
    } else {
      dialogRef = this.dialog.open(ConfigureFilterComponent, {
        width: "500px",
        disableClose: true,
        data: {
          message: "Configure this filter",
          id: id,
          field: field,
          auto: auto,
        },
        panelClass: ["canvas-dialog", "dialog-right", "dialog-larger"],
        position: { top: rect.top - 100 + "px", left: rect.left - 520 + "px" },
      });
    }

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.selectFilter(false, index);
        if (result) {
          this.filterFields[index] = result;

          if (
            this.filterLogicMapping &&
            this.filterLogicMapping.mappingList &&
            this.filterLogicMapping.mappingList.length > 0 &&
            logic
          ) {
            const data = {
              filterId: this.filterFields[this.filterFields.length - 1].id,
              filterOperation: "and",
              filterLevel: 0,
            };

            this.filterLogicMapping.mappingList.push(data);
            this.filterLogicMapping.mappingString =
              this.filterLogicMapping.mappingString +
              " and " +
              this.filterFields.length;
            this.childForm.controls["filterLogicMapping"].setValue(
              this.filterLogicMapping
            );
            const e: any = null;

            this.openmappingList(e);
          }
          this.buildAggregateData();
        }
      } else {
        if (auto) this.removeDataField(null, this.filterFields.length - 1);
        else this.selectFilter(false, index);
      }
      this.fieldForm.get("selectItem")!.setValue("");
    });
  }

  fieldConfiguation(data: any) {
    let returnvalue = "";
    data.forEach((element: any) => {
      if (element.value) {
        returnvalue += element.value + " ";
      }
    });
    return returnvalue;
  }

  removeDataField(event: any, index: number) {
    this.selectFilter(true, index);
    const elem = "filterRight-" + index;
    const element = document.getElementById(elem);
    let messageDetail = "";
    if (
      this.filterLogicMapping &&
      this.filterLogicMapping != null &&
      this.filterLogicMapping.mappingList.length > 0
    )
      messageDetail = "Removal of this field will affect advanced logic";
    const rect = element
      ? element.getBoundingClientRect()
      : { top: 0, left: 0 };

    if (event) {
      event.stopPropagation();
      const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
        disableClose: true,
        data: {
          message: "Remove this filter?",
          messageDetail: messageDetail,
          actionButton: "remove",
        },
        panelClass: ["canvas-dialog", "dialog-right"],
        position: { top: rect.top - 50 + "px", left: rect.left - 380 + "px" },
      });

      dialogRef.afterClosed().subscribe((result) => {
        this.selectFilter(false, index);
        if (result) {
          let dp = this.filterFields[index].dataPoint.data.id;
          this.filterFields.splice(index, 1);
          //this.deleteItem(index);
          if (this.filterFields.length <= 0) {
            this.childForm.controls["collection"].setValue(null);
          }
          if (
            this.filterLogicMapping &&
            this.filterLogicMapping.mappingList.length > 0
          ) {
            this.filterLogicMapping.mappingList =
              this.filterLogicMapping.mappingList.filter(
                (item: any) => item.filterId !== dp
              );
            this.childForm.controls["filterLogicMapping"].setValue(
              this.filterLogicMapping
            );
            const e: any = null;
            this.openmappingList(e);
          }

          this.buildAggregateData();
        }
      });
    } else {
      this.filterFields.splice(index, 1);
      if (this.filterFields.length <= 0) {
        this.childForm.controls["collection"].setValue(null);
      }
      // this.buildAggregateData();
    }
  }
  changeCondition(id: any) {
    let conditionItems = this.fieldForm.get("conditions") as UntypedFormArray;
    let condition = conditionItems.controls[id].get("condition")!.value;
    if (condition == "and") {
      condition = "or";
    } else {
      condition = "and";
    }

    conditionItems.controls[id].get("condition")!.setValue(condition);
    this.buildAggregateData();
  }
  buildAggregateData() {
    let conditionItem = this.fieldForm.get("conditions") as UntypedFormArray;

    this.filterFields.forEach((filter, index) => {
      if (index == 0) {
        filter.condition = "na";
      }
      if (index != 0) {
        filter.condition = conditionItem.controls[index - 1].value.condition;
      }
    });
    this.aggregateData = this.commonService.generateFilters(this.filterFields);
    this.childForm.get("filterdata")!.setValue(this.aggregateData);

    let callpreview = true;
    this.aggregateData.forEach((filter: any) => {
      if (filter.modifications && filter.modifications[0].value) {
        callpreview = true;
      } else {
        callpreview = false;
      }
    });

    if (callpreview) {
      this.canvasService.refreshCanvas(this.childForm).subscribe(
        (success: any) => {
          this.canvasService.triggerEnable();
          const data = success.data;
          this.canvasService.pushChartToStorage(data);
          this.canvasService.populateCanvas(data);
        },
        (error: any) => {
          this.canvasService.triggerEnable();
          const data = this.canvasService.getChartFromStorage();
          this.canvasService.populateCanvas(data);
        }
      );
    }
  }

  selectFilter(condition: boolean, filterID: any) {
    if (condition) {
      this.selectedIndex = filterID;
    } else {
      this.selectedIndex = -1;
    }
  }

  ngOnChanges() {
    if (this.currentFilterFields) {
      this.filterFields = this.currentFilterFields;
      if (this.fieldForm) {
        let condition = this.fieldForm.get("conditions") as UntypedFormArray;
        condition.clear();
      }

      this.filterFields.forEach((filter, index) => {
        let conditionVal = "";
        if (filter.fields && filter.fields.data) {
          conditionVal = filter.fields.data[0].condition;
        }

        if (index > 0) {
          this.addItem(conditionVal);
        }
      });
    }
  }

  initForm() {
    this.fieldForm = this.fb.group({
      selectItem: new UntypedFormControl(""),
      field: new UntypedFormControl(""),
      conditions: this.fb.array([]),
    });

    this.filterFields.forEach((filter, index) => {
      let conditionVal = "";
      if (filter.fields && filter.fields.data) {
        conditionVal = filter.fields.data[0].condition;
      }

      if (index > 0) {
        this.addItem(conditionVal);
      }
    });
  }

  ngOnInit(): void {
    this.childForm = this.parentF.form;
    if (this.childForm) {
      this.chartID = this.childForm.get("itemId").value;
      this.filterLogicMapping = this.childForm.get("filterLogicMapping")!.value;
    }
    this.initForm();
  }
}
